module.exports = __webpack_public_path__ + "img/GOV_SUITE_COLORED.a69440a7.png";